export const TRANSLATION_PENDING = 'TRANSLATION_PENDING';
export const TRANSLATION_IN_PROCESS = 'TRANSLATION_IN_PROCESS';
export const TRANSLATION_FAILED = 'TRANSLATION_FAILED';
export const TRANSLATION_SUCCESS = 'TRANSLATION_SUCCESS';
